import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "building.icon",
  "use": "building.icon-usage",
  "viewBox": "0 0 65.082 65.078",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 65.082 65.078\" id=\"building.icon\"><path data-name=\"Union 37\" d=\"M-11817-573.922v-3.717h7.438V-639h14.877v5.575h22.313v55.785h20.455v3.717Zm40.908-3.717v-52.069h-18.594l-1.854.006v-.006h-9.3v52.069h7.432v-9.3h14.875v9.292l-.928.005Zm-10,0v-6.083h-9.76v6.083Zm-10.449-55.785v-3.717h-11.158v3.717Zm-3.727,37.19v-3.717h18.594v3.717Zm0-11.156v-3.717h18.594v3.717Zm0-11.156v-3.722h18.594v3.722Z\" transform=\"translate(11817 639)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/building.icon.svg
// module id = PVGL
// module chunks = 13